import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Common } from 'src/app/models/Common';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
  selector: 'app-a-input',
  templateUrl: './a-input.component.html',
  styleUrls: ['./a-input.component.scss'],
})
export class AInputComponent implements OnInit {


  @Input() validations: string[] = [];
  @Input() validationObject: Common;

  @Input() label: string;
  @Input() debounce: number = 0;
  @Input() variable: any;
  @Input() type: any;
  @Input() customClass: string;
  @Input() maxLength: number;
  @Input() minLength: number;
  @Input() icon: string;
  @Input() clearIcon: boolean = false;
  @Input() disabled: boolean = false;
  @Input() placeholder: string;

  @Input() isMandatory: boolean = false;
  @Input() clearInput: boolean = false;
  @Output() variableChange = new EventEmitter<any>();
  @Output() enterKey = new EventEmitter<string>();
  @Output() onType = new EventEmitter<string>();
  @Output() onBlur = new EventEmitter<string>();
  @Output() clickIcon = new EventEmitter<string>();


  validationMessage: string = null;
  constructor(
    public themeService: ThemeService,
    private router: Router
  ) { }

  ngOnInit() {
    if (this.validations && this.validations.length > 0 && this.validations.includes("mandatory")) {
      this.label = this.label + " *";
    }
  }



  ngOnChanges(changes: SimpleChanges) {
    // console.log(changes);
    if (this.validations.includes("Check Validation")) {
      this.checkValidation();
    }
  }
  onTypeIn() {
    this.onType.emit(this.variable);
  }


  editInput() {
    if (this.type == "number") {
      this.variable = Number(this.variable);
    }
    this.variableChange.emit(this.variable);
  }

  // Handle icon click event
  onIconClick() {
    this.clickIcon.emit(this.variable);
  }

  checkFocus() {
    this.checkValidation();
    this.onBlur.emit(this.variable);
  }
  checkValidation() {
    if (!this.validations.includes("mandatory") && (!this.variable || this.variable.length == 0)) {
      this.validationMessage = "";
      return true;
    }
    if (this.validationObject) {
      this.validationMessage = null;
      if (!this.validationObject.pageValidation || this.validationObject.pageValidation.set == null) {
        this.validationObject.pageValidation = new Map();
        // console.log(this.validationObject.pageValidation);
      }
      // console.log(this.label, this.variable);
      // console.log(this.validationObject.pageValidation);
      this.validationObject.pageValidation.set(this.label, []);
      for (let valid of this.validations) {
        switch (valid) {
          case "name": {

            let nameRegex = /^[a-zA-Z ]+$/g;
            if (!nameRegex.test(this.variable)) {
              this.validationMessage = this.label + " should have valid character";
              this.validationObject.pageValidation.get(this.label).push(this.validationMessage);
            }
            break;
          }
          case "az09": {
            let nameRegex = /^[A-Za-z0-9]+$/g;
            if (!nameRegex.test(this.variable)) {
              this.validationMessage = this.label + " should have valid character";
              this.validationObject.pageValidation.get(this.label).push(this.validationMessage);
            }
            break;
          }
          case "az09_-": {
            let nameRegex = /^[A-Za-z0-9_-]+$/g;
            if (!nameRegex.test(this.variable)) {
              this.validationMessage = this.label + " should have valid character";
              this.validationObject.pageValidation.get(this.label).push(this.validationMessage);
            }
            break;
          }
          case "onlyNumber": {
            let nameRegex = /^[0-9]+$/g;
            if (!nameRegex.test(this.variable)) {
              this.validationMessage = this.label + " should have valid number only";
              this.validationObject.pageValidation.get(this.label).push(this.validationMessage);
            }
            break;
          }
          case "email": {
            let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let nameRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
            if (!nameRegex.test(this.variable)) {
              this.validationMessage = this.label + " should have valid email";
              this.validationObject.pageValidation.get(this.label).push(this.validationMessage);
            }
            break;
          }

          case "mandatory": {
            if (this.type != 'number') {
              if (this.variable == null || this.variable.trim().length == 0) {
                this.validationMessage = this.label + " is Mandatory";
                this.validationObject.pageValidation.get(this.label).push(this.validationMessage);
              }
            } else {
              if (isNaN(this.variable)) {
                this.validationMessage = this.label + " is Mandatory";
                this.validationObject.pageValidation.get(this.label).push(this.validationMessage);
              }
            }
            break;
          }
          default: {
            if (valid.indexOf('length') > -1) {
              if (valid.indexOf("==") > -1) { this.lengthCheck(valid, "==", "exact"); }
              if (valid.indexOf(">=") > -1) { this.lengthCheck(valid, ">=", "greater than or equal"); }
              if (valid.indexOf("<=") > -1) { this.lengthCheck(valid, "<=", "less than or equal"); }
              if (valid.indexOf("<") > -1) { this.lengthCheck(valid, "<", "greater than"); }
              if (valid.indexOf(">") > -1) { this.lengthCheck(valid, ">", "less than"); }
            }

          }
        }
      }
    }
  }

  checkReg(reg) {
    let nameRegex = /^[A-Za-z0-9_-]+$/g;
    if (nameRegex && !nameRegex.test(this.variable)) {
      this.validationMessage = this.label + " should have valid character";
      this.validationObject.pageValidation.get(this.label).push(this.validationMessage);
    }
  }

  lengthCheck(valid, opString, message) {

    let len = Number(valid.split(opString)[1]);
    let len2 = (this.variable + "").trim().length;
    let result = opString == "==" && len2 != len;
    switch (opString) {
      case "==": result = len2 != len; break;
      case ">=": result = len2 < len; break;
      case "<=": result = len2 > len; break;
      case "<": result = len2 >= len; break;
      case ">": result = len2 <= len; break;
    }
    // console.log(len, opString, len2, "==", result);
    if (result) {
      this.validationMessage = this.label + " should have " + message + " length: " + len;
      this.validationObject.pageValidation.get(this.label).push(this.validationMessage);
    }
  }

  clickIconIn() {
    this.clickIcon.emit("");
  }

  keyEnter() {
    this.enterKey.emit(this.variable);
  }

  numericOnly(event): boolean { // restrict e,+,-,E characters in  input type number
    if (this.type == "number") {
      const charCode = (event.which) ? event.which : event.keyCode;
      if (charCode == 101 || charCode == 69 || charCode == 45 || charCode == 43) {
        return false;
      }
      return true;
    }

  }

  onPaste(event: ClipboardEvent) {
    if (this.type == "number") {
      let clipboardData = event.clipboardData;
      let pastedText = clipboardData.getData('text');
      if (!Number(pastedText)) {
        event.preventDefault();
      }
    }
  }

}
